/** Normalise an RU/raw money string to a dot-decimal string for the API. */
export function normaliseDecimal(raw: string): string {
  return raw.trim().replace(/\s/g, "").replace(",", ".");
}
